import useToggle from "hooks/useToggle";
import { useState } from "react";
import {
  Alert,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import FieldUtils from "utils/FieldUtils";
import { callFunctionIfExists } from "utils/GeneralUtils";

const Password = ({
  className = "",
  autoComplete = "new-password",
  placeholder = "Password",
  name = "password",
  onChange,
  setValidPassword = null, // Valid flag sended to parent component to enable/disable submit button
  required = true,
  userEmail,
  showIcon = true,
  useError = true,
}) => {
  const [visibility, toggleVisibilty] = useToggle();
  const [passwordValue, setPasswordValue] = useState("");
  const [error, setError] = useState(undefined);

  const handleChange = (e) => {
    const password = e.target.value;
    onChange(e);
    setPasswordValue(password);

    const result = FieldUtils.validatePasswordInput(password, userEmail);

    if (result.valid === true) {
      callFunctionIfExists(setValidPassword, true);
      return setError(null);
    } else {
      callFunctionIfExists(setValidPassword, false);
      setError(result.message);
    }
  };

  return (
    <>
      <InputGroup>
        {showIcon ? (
          <InputGroupAddon addonType="prepend">
            <InputGroupText style={{ height: 46 }}>
              <i
                className="mdi mdi-lock"
                style={{ fontSize: "18px", lineHeight: "1" }}
              />
            </InputGroupText>
          </InputGroupAddon>
        ) : null}
        <Input
          type={visibility ? "text" : "password"}
          name={name}
          className={`tw:focus:border-gray-300 ${className}`}
          value={passwordValue}
          onChange={handleChange}
          autoComplete={autoComplete}
          placeholder={placeholder}
          required={required}
          style={{ borderRight: "none" }}
        />
        <InputGroupAddon addonType="append">
          <InputGroupText
            className="cursor-pointer"
            onClick={toggleVisibilty}
            style={{ height: 46 }}
          >
            <i
              className={visibility ? "mdi mdi-eye-off" : "mdi mdi-eye"}
              style={{ fontSize: "18px", lineHeight: "1" }}
            />
          </InputGroupText>
        </InputGroupAddon>
      </InputGroup>
      {useError && error && (
        <Alert
          color={error === null ? "success" : "warning"}
          className={`mt-3 py-2 px-3 ${error === null ? "text-center" : ""}`}
        >
          {error === null ? (
            <></>
          ) : Array.isArray(error) ? (
            error.map((e, i) => (
              <div key={i} className={i > 0 ? "mt-2" : ""}>
                {e}
              </div>
            ))
          ) : (
            error
          )}
        </Alert>
      )}
    </>
  );
};

export default Password;
